import { IProject } from '~/types/projects';
import { Animate } from '~/components';

import ProjectCard from '../ProjectCard';

type ProjectProps = {
	data?: IProject[];
};

const Projects = ({ data: overwriteProjects }: ProjectProps) => {
	const projectsList = overwriteProjects;
	return (
		<div className="grid items-start grid-cols-1 gap-8 md:grid-cols-2">
			{projectsList.map((item, index) => {
				return (
					<Animate
						animation={{ y: [50, 0], opacity: [0, 1] }}
						key={index}
						transition={{
							delay: 0.1 * index,
						}}>
						<ProjectCard key={item.id} project={item} />
					</Animate>
				);
			})}
		</div>
	);
};

export default Projects;
